var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import HitList from './HitList';
import NoResults from '../NoResults/NoResults';
import { usePhoneView } from '@michelin/acid-components';
import HitDetail from './HitDetail';
import { isDark } from '../../../types/Theme';
var useStyles = makeStyles(function (theme) { return createStyles({
    detailDark: {
        backgroundColor: theme.palette.background.paper,
    },
    container: {
        flexGrow: 1,
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        transition: 'all 0.3s',
        borderTop: '1px solid #515253',
    }
}); });
var Hits = function (_a) {
    var hasResults = _a.hasResults, results = _a.results;
    var _b = __read(useState(), 2), selectedHit = _b[0], setSelectHit = _b[1];
    var phoneView = usePhoneView();
    var classes = useStyles();
    var dark = isDark();
    return (React.createElement("div", { className: "".concat(dark ? classes.detailDark : '', " ").concat(classes.container), style: { padding: !hasResults ? '0px 30px 30px 30px' : 0 } }, hasResults ? (React.createElement(React.Fragment, null,
        React.createElement(HitList, { setSelectHit: setSelectHit, selectedHit: selectedHit, results: results }),
        !phoneView && React.createElement(HitDetail, { selectedHit: selectedHit }))) : React.createElement(NoResults, null)));
};
export default Hits;
//# sourceMappingURL=Hits.js.map